/* Keep support chat clear of the purchase bar, including wrapped selections. */
(()=>{
 const bar=document.getElementById('pdp-sticky');if(!bar)return;
 const update=()=>document.documentElement.style.setProperty('--pdp-sticky-clearance',bar.hidden?'0px':Math.ceil(bar.getBoundingClientRect().height)+'px');
 if('ResizeObserver' in window)new ResizeObserver(update).observe(bar);
 new MutationObserver(update).observe(bar,{attributes:true,attributeFilter:['hidden']});
 window.addEventListener('resize',update,{passive:true});update();
})();
